export default __webpack_public_path__ + "media/images/images/gallery/2-22334aab40f201fd22268610882f46e0.jpg";